import { CommonModule } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, inject, Input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'la-panel',
  styleUrls: ['./panel.component.scss'],
  templateUrl: './panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule, MatRippleModule],
})
export class PanelComponent {
  @Input({ transform: booleanAttribute }) collapsible = false;

  isCollapsed = false;
  cd = inject(ChangeDetectorRef);

  @HostBinding('class.collapsed')
  get collapsedClass(): boolean {
    return this.isCollapsed;
  }

  toggleCollapse(): void {
    if (this.collapsible) {
      this.isCollapsed = !this.isCollapsed;
      this.cd.markForCheck();
    }
  }
}
